<template>
  <div class="button">
    <span class="button__name typography__body2">
      <BaseIcon2
        :id="`icon-${social}`"
        class="button-icon"
        sprite="socials"
      />

      {{ SOCIALS[social].name }}
    </span>

    <Component
      :is="connected || disabledConnect ? 'span' : BaseLink"
      class="typography__label1"
      :class="[connected ? 'ui-link-primary' : 'ui-link-secondary', { disabled: disabledConnect && !connected }]"
      v-bind="{ ...(!connected && !disabledConnect && { href: redirectUrl }) }"
    >
      {{ connected ? t("common.authorized") : disabledConnect ? t("common.notAuthorized") : t("common.connect") }}
    </Component>
  </div>
</template>

<script lang="ts" setup>
type Project = "crm" | "cv";

type Social = "google" | "mailru" | "telegram" | "vk" | "yandex";

interface Props {
  connected: boolean;
  disabledConnect?: boolean;
  params?: Record<string, string>;
  project?: Project;
  redirectTo?: string;
  social: Social;
}

interface SocialParameters {
  name: string;
}

const { t } = useI18n();
const props = defineProps<Props>();
const { connected, params, project, redirectTo, social } = toRefs(props);
const BaseLink = resolveComponent("BaseLink");
const config = useRuntimeConfig();
const { $env } = useNuxtApp();

const SOCIALS: Record<Social, SocialParameters> = {
  google: {
    name: "Google",
  },
  mailru: {
    name: "Mail.Ru",
  },
  telegram: {
    name: "Telegram",
  },
  vk: {
    name: "ВКонтакте",
  },
  yandex: {
    name: "Яндекс",
  },
};

const redirectUrl = computed(() => {
  if (social.value === "telegram") {
    return redirectTo.value;
  }

  // Проверяем, есть ли уже протокол в redirectTo
  let finalRedirectTo = redirectTo.value;
  if (redirectTo.value && !redirectTo.value.startsWith("http://") && !redirectTo.value.startsWith("https://")) {
    // Если протокола нет - добавляем базовый URL
    const baseUrl = $env.isDev ? "http://mydonut.local" : config.public.baseUrl;
    const [protocol, host] = baseUrl.split("://");
    finalRedirectTo = `${protocol}://${host}${redirectTo.value.startsWith("/") ? "" : "/"}${redirectTo.value}`;
  }
  // Если протокол есть - используем как есть

  const queryParameters = createQueryParameters({
    redirect_to: finalRedirectTo,
    ...params.value,
  });

  const baseUrl = $env.isDev ? "http://mydonut.local" : config.public.baseUrl;
  const [protocol, host] = baseUrl.split("://");

  return `${protocol}://api-${project.value}.${host}/auth/${social.value}${queryParameters}`;
});
</script>

<style scoped>
.button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 8px;
}

.button__name {
  display: flex;
  align-items: center;
  column-gap: 8px;
}

.button-icon {
  width: 24px;
  height: 24px;
}

.disabled {
  color: var(--grey-2);
}
</style>
